/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Testimonial_Erin_BarnesInputs */

const en_testimonial_erin_barnes = /** @type {(inputs: Testimonial_Erin_BarnesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The app is impressive, easy to listen to, no robotic voice, easy to use. Productive use of my driving time. Would recommend.`)
};

const es_testimonial_erin_barnes = /** @type {(inputs: Testimonial_Erin_BarnesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La app es impresionante, fácil de escuchar, sin voz robótica, fácil de usar. Uso productivo de mi tiempo de conducción. La recomendaría.`)
};

/**
* | output |
* | --- |
* | "The app is impressive, easy to listen to, no robotic voice, easy to use. Productive use of my driving time. Would recommend." |
*
* @param {Testimonial_Erin_BarnesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const testimonial_erin_barnes = /** @type {((inputs?: Testimonial_Erin_BarnesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Testimonial_Erin_BarnesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_testimonial_erin_barnes(inputs)
	return en_testimonial_erin_barnes(inputs)
});